import { createFileRoute, redirect } from '@tanstack/react-router';

import { PaymentCancelPage } from '@/pages/payments';

export const Route = createFileRoute('/_user/payment/cancel')({
  beforeLoad: async ({ context }) => {
    const user =
      context.auth.user ?? (await context.auth.userRefetch().catch(() => null));

    if (!user) {
      throw redirect({ to: '/sign-in' });
    }
  },
  component: PaymentCancelPage,
});
